import { useId } from "react";

export type VosIconVariant = "InBehandeling" | "Actief" | "Afgerond";

function Clock() {
    return (
        <path
            d="M17 10C20.8587 10 24 13.1413 24 17C24 20.8587 20.8587 24 17 24C13.1413 24 10 20.8587 10 17C10 13.1413 13.1413 10 17 10ZM17 12.5547C16.5187 12.5547 16.125 12.9484 16.125 13.4297V17.3672L18.1641 19.4062C18.339 19.5723 18.5578 19.6602 18.7852 19.6602C19.0125 19.6601 19.2313 19.5811 19.4062 19.4062C19.7475 19.065 19.7475 18.5131 19.4062 18.1719L17.875 16.6406V13.4297C17.875 12.9484 17.4812 12.5547 17 12.5547Z"
            className="text-content-info"
            fill="currentColor"
        />
    );
}

function Check() {
    return (
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 17C10 13.13 13.13 10 17 10C20.87 10 24 13.13 24 17C24 20.87 20.87 24 17 24C13.13 24 10 20.87 10 17ZM16.13 20.2L20.55 15.39H20.56C20.84 15.08 20.82 14.61 20.51 14.33C20.2 14.05 19.73 14.07 19.45 14.38L16.09 18.04L14.53 16.48C14.24 16.19 13.76 16.19 13.47 16.48C13.18 16.77 13.18 17.25 13.47 17.54L16.13 20.2Z"
            className="text-content-success"
            fill="currentColor"
        />
    );
}

function Minus() {
    return (
        <path
            d="M17 10C20.8598 10.0001 23.9999 13.1402 24 17C24 20.8599 20.8599 23.9999 17 24C13.14 24 10 20.86 10 17C10.0001 13.1401 13.1401 10 17 10ZM13.5 16C13.2239 16 13 16.2239 13 16.5V17.5C13 17.7761 13.2239 18 13.5 18H20.5C20.7761 18 21 17.7761 21 17.5V16.5C21 16.2239 20.7761 16 20.5 16H13.5Z"
            className="text-chart-neutral"
            fill="currentColor"
        />
    );
}

type VosStatusProps = {
    variant: VosIconVariant;
};

export function VosStatus({ variant }: VosStatusProps) {
    const maskId = useId();

    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id={maskId} style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                <path d="M24 0H0V24H9V12L12 9H24V0Z" fill="#D9D9D9" />
            </mask>
            <g mask={`url(#${maskId})`}>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 4C14.3431 4 13 5.34315 13 7V8C13 9.65685 14.3431 11 16 11C17.6569 11 19 9.65685 19 8V7C19 5.34315 17.6569 4 16 4ZM16 5C14.8954 5 14 5.89543 14 7V8C14 9.10457 14.8954 10 16 10C17.1046 10 18 9.10457 18 8V7C18 5.89543 17.1046 5 16 5Z"
                    className="text-content-emphasis"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.5 5C6.11929 5 5 6.11929 5 7.5V8.5C5 9.88071 6.11929 11 7.5 11C8.88071 11 10 9.88071 10 8.5V7.5C10 6.11929 8.88071 5 7.5 5ZM7.5 6C6.67157 6 6 6.67157 6 7.5V8.5C6 9.32843 6.67157 10 7.5 10C8.32843 10 9 9.32843 9 8.5V7.5C9 6.67157 8.32843 6 7.5 6Z"
                    className="text-content-emphasis"
                    fill="currentColor"
                />
                <path
                    d="M11.0839 13.0839C11.7166 12.4513 12.5874 12 13.5 12C13.7761 12 14 12.2239 14 12.5C14 12.7761 13.7761 13 13.5 13C12.9126 13 12.2834 13.2987 11.7911 13.7911C11.2987 14.2834 11 14.9126 11 15.5V18H21V15.5C21 14.9126 20.7013 14.2834 20.2089 13.7911C19.7166 13.2987 19.0874 13 18.5 13C18.2239 13 18 12.7761 18 12.5C18 12.2239 18.2239 12 18.5 12C19.4126 12 20.2834 12.4513 20.9161 13.0839C21.5487 13.7166 22 14.5874 22 15.5V19H10V15.5C10 14.5874 10.4513 13.7166 11.0839 13.0839Z"
                    className="text-content-emphasis"
                    fill="currentColor"
                />
                <path
                    d="M3.08395 13.0839C2.45127 13.7166 2 14.5874 2 15.5V18H9V17H3V15.5C3 14.9126 3.29873 14.2834 3.79105 13.7911C4.28338 13.2987 4.91262 13 5.5 13C5.77614 13 6 12.7761 6 12.5C6 12.2239 5.77614 12 5.5 12C4.58738 12 3.71662 12.4513 3.08395 13.0839Z"
                    className="text-content-emphasis"
                    fill="currentColor"
                />
            </g>
            {variant === "InBehandeling" && <Clock />}
            {variant === "Actief" && <Check />}
            {variant === "Afgerond" && <Minus />}
        </svg>
    );
}
